import { Box, Tooltip, Typography } from '@mui/material';
import { useListContext, useTranslate } from 'react-admin';
import { BarChartWithTrend } from '@/components/analytics/common/BarChartWithTrend.jsx';
import { calcGrowth, prepareTrendChartData } from '@/helpers/analytics/charts.js';
import { formatNumber, formatNumberWithComma } from '@/helpers/format/formatNumber.js';
import { Growth } from '@/components/analytics/common/Growth.jsx';
import { ChartAnalyticsCard } from '@/components/analytics/common/ChartAnalyticsCard.jsx';
import { Palette } from '@/themes/themeOverrides/Palette';

const Title = ({ value, growth, secondaryValue }) => {
    const translate = useTranslate();
    const tooltipContent = `${translate('analytics.common.uptimeGlobal')}: ${formatNumber(secondaryValue * 100, 1)}%`;

    return (
        <Box sx={{ mb: 4 }}>
            <Typography variant='h6'>{translate('common.uptime')}</Typography>
            <Tooltip title={tooltipContent}>
                <Box sx={{ display: 'flex', alignItems: 'center', paddingBottom: '14px', borderBottom: `2px solid ${Palette.gray.gray100}` }}>
                    <Typography variant='h3' sx={{ lineHeight: '36px', marginTop: '5px' }}>
                        {formatNumberWithComma(value * 100, 1)}%
                    </Typography>
                    <Growth value={growth} />
                </Box>
            </Tooltip>
        </Box>
    );
};

export const DeviceUptimeAnalytics = () => {
    const { data } = useListContext();
    const translate = useTranslate();

    if (!data || data.length === 0) return null;

    const analytic = data.find(s => s.id === 'current').data;
    const previous = data.find(s => s.id === 'previous').data;
    const series = data.find(s => s.id === 'series').data;
    const chartData = prepareTrendChartData(series, 'uptime');

    return (
        <ChartAnalyticsCard
            data={chartData}
            dataKey='uptime'
            stats={<Title value={analytic.uptime} growth={calcGrowth(analytic.uptime, previous.uptime)} secondaryValue={analytic.uptimeGlobal} />}
            chart={
                <BarChartWithTrend
                    data={chartData}
                    dataKey='uptime'
                    label={translate('common.uptime')}
                    secondaryDataKey='uptimeGlobal'
                    secondaryLabel={translate('analytics.common.uptimeGlobal')}
                    percent
                    barColorThresholds={[0.9, 0.75]}
                />
            }
        />
    );
};
